module.exports = __webpack_public_path__ + "static/theme-editor-social-icons-top-e3c8fc7da515eeb24fa07016a1924589.png";